import React, { ReactNode, memo } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Header, Footer, HeaderProps } from 'components/molecules';
import CookieBanner from 'components/atoms/CookieBanner';

interface LayoutProps extends Partial<HeaderProps> {
  children: ReactNode;
}

const Main = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  background: '#f7df1c',
})) as any; // Type assertion to allow component="main"

const Layout: React.FC<LayoutProps> = memo(({ children, isHomePage, ...rest }) => (
  <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    ...(isHomePage
      ? { height: '100dvh', overflow: 'hidden' }
      : { minHeight: '100vh' }
    )
  }}>
    <Header isHomePage={isHomePage} {...rest} />
    <Main as="main">{children}</Main>
    <Footer isHomePage={isHomePage} {...rest} />
    <CookieBanner />
  </Box>
));


export default Layout;